import { gql, useQuery } from '@apollo/client';

const GET_CASHFLOW_TEMPLATES = gql`
  query cashflowTemplates($input: CashflowTemplatesInput) {
    cashflowTemplates(input: $input) {
      templates {
        id
        name
        description
        modelType
        s3Bucket
        s3Key
        isPublished
        createdAt
        updatedAt
        publishedAt
        country {
          id
          displayName
        }
        createdBy {
          id
          firstName
          lastName
        }
        publishedBy {
          id
          firstName
          lastName
        }
      }
      totalCount
    }
  }
`;

export const useCashflowTemplates = (modelType) => {
  const { data, loading, error, refetch } = useQuery(GET_CASHFLOW_TEMPLATES, {
    variables: { input: { modelType } },
    fetchPolicy: 'network-only',
  });

  return {
    templates: data?.cashflowTemplates?.templates ?? [],
    totalCount: data?.cashflowTemplates?.totalCount ?? 0,
    refetch,
    loading,
    error,
  };
};
